// Footer language picker. Saves the choice (jm_lang cookie, which
// middleware.js honours on later visits) and moves to the same page in that
// language: every page exists at /, /es/... and /pt/....
import React from "react";
import { Globe } from "lucide-react";
import {
  LOCALES,
  useLocale,
  useT,
  type Locale,
} from "@jammable/ui-core/src/i18n";

// Each language named in itself, so it is findable whatever the UI is in.
const NAMES: Record<Locale, string> = {
  en: "English",
  es: "Español",
  pt: "Português",
  fr: "Français",
  de: "Deutsch",
  ja: "日本語",
  ko: "한국어",
  id: "Bahasa Indonesia",
  tr: "Türkçe",
};

export default function LanguageSwitcher() {
  const t = useT();
  const { locale, setLocale } = useLocale();

  return (
    <label className="tw-inline-flex tw-items-center tw-gap-2 tw-self-start tw-rounded-full tw-bg-white tw-px-4 tw-py-2 tw-text-[13px] tw-font-extrabold tw-text-jam-ink focus-within:tw-ring-2 focus-within:tw-ring-jam-purple">
      <Globe size={16} strokeWidth={2.5} aria-hidden="true" />
      <span className="tw-sr-only">{t("nav.language")}</span>
      <select
        value={locale}
        onChange={(e) => setLocale(e.target.value as Locale)}
        className="tw-cursor-pointer tw-border-0 tw-bg-transparent tw-text-[13px] tw-font-extrabold tw-text-jam-ink tw-outline-none"
      >
        {LOCALES.map((l) => (
          <option key={l} value={l} lang={l}>
            {NAMES[l]}
          </option>
        ))}
      </select>
    </label>
  );
}
